import { createRoot } from "react-dom/client";
import App from "./App.tsx";

// import "@/assets/vendor_assets/css/bootstrap/bootstrap.css";
import "./index.css";
import { HelmetProvider } from "react-helmet-async";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // cache 5 min
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});



createRoot(document.getElementById("root")!).render(
  <HelmetProvider>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </HelmetProvider>,
);
